














import { Component, Vue } from "vue-property-decorator";
import LectureForm from "@/components/lectures/LectureForm.vue";
import CBreadCrumbs from "@/components/form/CustomPage/CBreadCrumbs.vue";
@Component({
  components: { CBreadCrumbs, LectureForm }
})
export default class LectureNew extends Vue {
  get breadcrumbs() {
    return [
      {
        to: { name: "lectureList" },
        label: this.$tc(this.$translate.Lectures)
      },
      {
        label: this.$tc(this.$translate.Create)
      }
    ];
  }
}
